import styles from './styles.module.scss';
import React from 'react';
import PropTypes from 'prop-types';
import {keys} from 'lodash/object';
import {Col, Row} from 'reactstrap';

const propTypes = {
  groupBy: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  renderItem: PropTypes.func.isRequired,
};
const defaultProps = {
  titleTag: 'h4',
  colLeft: {lg: 4},
  colRight: {lg: 8},
};

function PublicListGroup(props) {
  const {titleTag, groupBy, items, renderItem, colLeft, colRight, ...rest} =
    props;

  let group = {};

  items.forEach((item) => {
    if (!item.hasOwnProperty(groupBy)) return; // Skip it, if item doesn't have property

    const groupKey = item[groupBy];
    if (!group.hasOwnProperty(groupKey)) group[groupKey] = []; // if group is new, set array.

    group[groupKey].push(item);
  });

  return (
    <ul className={styles['public-list-group']} {...rest}>
      {keys(group).map((groupKey, index) => {
        const groupItem = group[groupKey];

        return (
          <li key={index} className={styles['public-list-group__item']}>
            <Row>
              <Col {...colLeft}>
                {React.createElement(
                  titleTag,
                  {className: styles['public-list-group__item-title']},
                  groupKey
                )}
              </Col>
              <Col {...colRight}>{renderItem(groupItem)}</Col>
            </Row>
          </li>
        );
      })}
    </ul>
  );
}

PublicListGroup.propTypes = propTypes;
PublicListGroup.defaultProps = defaultProps;

export default PublicListGroup;
